import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import telematicsService from "../../api/telematics.service";
import moment from "moment";

export default {
  name: "events",
  components: { pageheader },
  props: ["respData"],
  data() {
    return {
      input: {},
      search: "",
      toggle_exclusive: 0,
      showMissed: true,
      isEventsLoading: false,
      eventsData: {},
      eventsList: [],
      eventsListActive: [],
      header_events: [
        // { text: "Logo", value: "actionIcon", sortable: false, align: "left" },
        { text: "Status", value: "status" },
        { text: "Date", value: "timeOn" },
        { text: "Type", value: "typeDescription" },
        {
          text: "Description",
          value: "description",
          width: "18%",
        },
        // { text: "created Date", value: "createdDate" },

        {
          text: "Occurrences",
          value: "occurrenceCount",
        },
        {
          text: "Criticality",
          value: "criticality",
        },

        // {
        //   text: "Occurrence Count",
        //   value: "occurrenceCount",
        // },
      ],
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.input = utils.getInputContent("events", this.roles);
    // this.responseData = this.respData;
    // this.responseData = this.respData;
    // this.eventsList = this.responseData.faultEvents;

    if (this.$route.params.assetId) {
      this.readEventDetailsById("");
    }
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "YYYY-MM-DD";
        return moment(value).format(format);
      }
    },
    formatDateTime: function (value) {
      if (value) {
        const format = "YYYY-MM-DD hh:mm:ss A";
        return moment(value).format(format);
      }
    },
    formattoLocalDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment.utc(value).local().format(format);
      }
    },
    getDifference: function (value) {
      if (value) {
        return moment(value).fromNow();
      }
    },
  },
  methods: {
    async readEventDetailsById(criticality) {
      this.eventsData = {};
      this.eventsList = [];
      this.eventsListActive = [];
      this.isEventsLoading = true;
      if (this.$route.params.assetId) {
        try {
          let response = await telematicsService.readEventDetailsById(
            this.$route.params.assetId,
            criticality
          );
          if (response.isSuccess && response.data) {
            this.isEventsLoading = false;
            this.eventsData = response.data;
            this.eventsList = this.eventsData.allEvents
              ? this.eventsData.allEvents
              : [];
            this.eventsListActive = this.eventsData.activeEvents
              ? this.eventsData.activeEvents
              : [];
          } else {
            this.isEventsLoading = false;
            this.$toast.error(response.systemMessage);
            this.eventsData = {};
          }
        } catch (error) {
          this.isEventsLoading = false;
          this.$toast.error("Unable to load the events" + error);
        }
      }
    },
  },
};
